import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmposition/cecUnmPosition/save',
      method: 'post',
      data: inputForm
    })
  },

  batchOperation: function (inputForm) {
    return request({
      url: '/cecunmposition/cecUnmPosition/batchOperation',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmposition/cecUnmPosition/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmposition/cecUnmPosition/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmposition/cecUnmPosition/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmposition/cecUnmPosition/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmposition/cecUnmPosition/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmposition/cecUnmPosition/import',
      method: 'post',
      data: data
    })
  }
}
